/*
 * ---------------------------------------------------------------------
 * import modules
 * ---------------------------------------------------------------------
 */
import React, { Component, Fragment } from 'react';

import './deploy-env.css';


/**
 * ---------------------------------------------------------------------
 * DeployEnvContainer React Component
 * ---------------------------------------------------------------------
 * to avoid brainfucks!
 *
 * @prop [number]  zindex         [optional] default 5001
 * @prop [bool]    disable        [optional] default false
 * @prop [bool]    disableDev     [optional] default false
 * @prop [bool]    disableTest    [optional] default false
 */
class DeployEnvFrame extends Component {

    render() {
        const env = process.env.REACT_APP_DEPLOY_ENV;

        if( env === "live" || env === "stage" || this.props.disable ) {
            return( null );
        }

        if( env === "development" && this.props.disableDev ) {
            return( null );
        }

        if( env === "test" && this.props.disableTest ) {
            return( null );
        }
        let cssLabel = "lbl " + env;
        let cssTop = "frame-top bg " + env;
        let cssLeft = "frame-left bg " + env;
        let cssRight = "frame-right bg " + env;
        let cssBottom = "frame-bottom bg " + env;

        let lblEnv = env.toUpperCase();

        let zIndex = 5001;
        if( this.props.zindex )
            zIndex = this.props.zindex;

        let style = {
            zIndex : zIndex
        }

        return (<Fragment>
                <div style={style} className={cssTop}>
                    <div className={cssLabel}>{ lblEnv } BUILD</div>
                </div>
                <div style={style} className={cssLeft}>
                </div>
                <div style={style} className={cssRight}>
                </div>
                <div style={style} className={cssBottom}>
                    <div className={cssLabel}>{ lblEnv } BUILD</div>
                </div>
            </Fragment>);
    }
}
/*
 * ---------------------------------------------------------------------
 * Export
 * ---------------------------------------------------------------------
 */
export default DeployEnvFrame;
